/* Packages */
import React from 'react';
import { hydrate } from 'react-dom';

/* Components */
import Search from './components/Search';

/* utilities */
import { parseDataToProps } from '~/utilities';

const searchNodes = Array.from(document.querySelectorAll('[data-search]'));
[...searchNodes].forEach((node) => hydrate(<Search {...parseDataToProps(node.dataset)} />, node));
